

import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_ADMINS_REQUEST = "FETCH_ADMINS_REQUEST";
export const FETCH_ADMINS_SUCCESS = "FETCH_ADMINS_SUCCESS";
export const FETCH_ADMINS_FAILURE = "FETCH_ADMINS_FAILURE";

export const UPDATE_ADMIN_REQUEST = "UPDATE_ADMIN_REQUEST";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_FAILURE = "UPDATE_ADMIN_FAILURE";

export const CREATE_ADMIN_REQUEST = "CREATE_ADMIN_REQUEST";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_FAILURE = "CREATE_ADMIN_FAILURE";


// Action types
export const FETCH_PROGRAMMES_REQUEST = "FETCH_PROGRAMMES_REQUEST";
export const FETCH_PROGRAMMES_SUCCESS = "FETCH_PROGRAMMES_SUCCESS";
export const FETCH_PROGRAMMES_FAILURE = "FETCH_PROGRAMMES_FAILURE";

// Fetch All Admins
export const fetchAdmins = () => async (dispatch) => {
  dispatch({ type: FETCH_ADMINS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/getAllAdmin`, {
      headers: {
        authorization: token,
      },
    });

    dispatch({
      type: FETCH_ADMINS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMINS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update Admin
export const updateAdmin = (adminData, onSuccess) => async (dispatch) => {
  dispatch({ type: UPDATE_ADMIN_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(`${BASE_URL}/v1/api/updateAdmin`, adminData, {
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });

    dispatch({
      type: UPDATE_ADMIN_SUCCESS,
      payload: response.data?.data || adminData,
    });

    toast.success("Admin updated successfully!");

    if (onSuccess) onSuccess(); // optional callback
    // Refresh data after update
    dispatch(fetchAdmins());
  } catch (error) {
    toast.error("Failed to update admin");
    dispatch({
      type: UPDATE_ADMIN_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};


export const createAdmin = (adminData, onSuccess) => async (dispatch) => {
  dispatch({ type: CREATE_ADMIN_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/createAdmin`, adminData, {
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });

    dispatch({
      type: CREATE_ADMIN_SUCCESS,
      payload: response.data?.data,
    });

    toast.success("Admin created successfully!");
    if (onSuccess) onSuccess();

    // Optionally refresh admin list
    dispatch(fetchAdmins());
  } catch (error) {
    toast.error("Failed to create admin");
    dispatch({
      type: CREATE_ADMIN_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};


// Fetch All Programmes
export const fetchProgrammes = () => async (dispatch) => {
  dispatch({ type: FETCH_PROGRAMMES_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/getAllProgrammes`, {
      headers: {
        authorization: token,
      },
    });

    dispatch({
      type: FETCH_PROGRAMMES_SUCCESS,
      //payload: response.data.data, // only the `data` array from API
       payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROGRAMMES_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};